{
  "loading": "Laddar...",
  "error": "Ett fel uppstod",
  "save": "Spara",
  "cancel": "Avbryt",
  "back": "Tillbaka",
  "success": "Framgång",
  "info": "Info",
  "ok": "OK",
  "skip": "Hoppa över",
  "later": "Senare",
  "update_now": "Uppdatera nu",
  "update_available_title": "Uppdatering tillgänglig",
  "update_available_message": "Version {{latestVersion}} finns tillgänglig. Du använder {{currentVersion}}.",
  "failed_to_save_language": "Det gick inte att spara språkpreferensen.",
  "logo_accessibility": "Vocalise-logotyp",
  "page_title_app": "Vocalise",
  "page_title_onboarding": "Vocalise Introduktion",
  "page_title_create_account": "Vocalise Skapa konto",
  "page_title_purchase": "Vocalise Köp",
  "page_title_voucher": "Vocalise Kupong",
  "page_title_settings": "Vocalise Inställningar",
  "page_title_session": "Vocalise Session",
  "page_title_preview_session": "Vocalise Förhandsgranska session",
  "page_title_library": "Vocalise Bibliotek",
  "page_title_dashboard": "Vocalise Översikt",
  "page_title_statistics": "Vocalise Statistik",
  "page_title_report_issue": "Vocalise Rapportera problem",
  "sentry_error_title": "Något gick fel",
  "sentry_error_message": "Ett oväntat fel inträffade.",
  "sentry_error_report_issue": "Lägg till detaljer i rapporten",
  "error_try_again": "Försök igen",
  "error_sign_out": "Logga ut",
  "error_go_back": "Gå tillbaka",
  "toast_dismiss_a11y": "Stäng aviseringen",
  "toast_retry": "Försök igen",
  "session_expired_title": "Sessionen har gått ut",
  "session_expired_message": "Logga in igen för att fortsätta.",
  "session_expired_continue": "Fortsätt till inloggning",
  "callback_completing_sign_in": "Slutför inloggning…",
  "beta_badge_label": "Beta",
  "beta_badge_accessibility_label": "Du testar just nu vår framtida funktionalitet. Fel i funktionen kan förekomma."
}
